import { motion, useAnimationControls } from 'framer-motion';
import { useEffect } from 'react';

import { cn } from '@/lib/utils';
import { usePageLoaderStore } from '@/store/page-loader-store';

interface Props {
  screen?: boolean;
}

export const PageLoader = ({ screen }: Props) => {
  const controls = useAnimationControls();
  const { rotation, incrementRotation } = usePageLoaderStore();

  useEffect(() => {
    const startAnimation = async () => {
      await controls.start({
        rotate: rotation + 360,
        transition: {
          duration: 3,
          ease: 'linear',
          repeat: Infinity,
          repeatType: 'loop',
        },
      });
    };

    startAnimation();

    return () => {
      controls.stop();
      // Update the rotation when component unmounts
      incrementRotation(360);
    };
  }, [controls, rotation, incrementRotation]);

  return (
    <div
      className={cn(
        'relative z-50 flex w-full flex-1 items-center justify-center bg-[#222222]',
        screen ? 'h-screen' : 'h-full',
      )}
    >
      <motion.div animate={controls} initial={{ rotate: rotation }}>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          className="size-[100px]"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" rx="20" fill="#A58763" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.3967 8.29971C27.5041 8.29973 27.6071 8.34295 27.6823 8.41964L29.618 10.3935C29.7284 10.5061 29.7328 10.685 29.628 10.8028L25.2466 15.7304L25.244 15.7333L25.2413 15.7361L22.6318 18.4469L22.6311 18.4477L21.1062 19.9996L28.8597 27.8878L29.8748 28.9242C29.989 29.0409 29.989 29.2275 29.8747 29.3441L27.6823 31.5798C27.607 31.6565 27.5041 31.6997 27.3966 31.6997H12.7043C12.5969 31.6997 12.4939 31.6565 12.4187 31.5798L10.2264 29.3442C10.112 29.2275 10.112 29.0406 10.2266 28.9239L18.9947 19.9996L10.2266 11.0753C10.112 10.9587 10.112 10.7718 10.2264 10.6551L12.4187 8.41964C12.4939 8.34294 12.5969 8.29972 12.7043 8.29971H27.3967ZM18.197 15.1427C17.563 14.8631 16.8814 14.8848 16.2781 15.0273C15.8093 15.1379 15.3978 15.3193 15.1103 15.4754L19.4176 19.8596L19.427 19.869L19.4349 19.8796C19.6078 20.1098 19.7189 20.2526 19.7686 20.4181C19.8091 20.553 19.8073 20.6967 19.8073 20.8843V25.3112L19.8071 25.3151C19.7976 25.5597 19.6934 25.8084 19.5386 26.0436C19.3825 26.2806 19.1662 26.5174 18.9119 26.7411C18.4033 27.1884 17.7252 27.5993 17.0193 27.8679C16.4193 28.0961 15.3556 28.2094 14.2908 28.2521C13.2641 28.2932 12.2043 28.2693 11.4914 28.2073L10.5806 29.1342L12.7043 31.2997H27.3966L29.5204 29.134L28.6337 28.2287C27.1557 28.2441 25.1792 28.6505 22.8047 27.8709C22.258 27.6914 21.6393 27.2722 21.1589 26.8041C20.9174 26.5687 20.7046 26.3149 20.5508 26.0645C20.3994 25.8177 20.2936 25.5554 20.2936 25.3074V20.8843C20.2936 20.6967 20.2917 20.553 20.3323 20.4181C20.382 20.2526 20.4931 20.1098 20.666 19.8796L20.6739 19.869L20.6833 19.8596L22.3436 18.1695L24.4412 15.9905C24.1248 16.0576 23.7122 16.1214 23.216 16.1478C21.9885 16.213 20.252 16.0491 18.197 15.1427Z"
            fill="#141414"
          />
        </svg>
      </motion.div>

      {/* <WordsPullUp
        text="Predict, Trade, Profit 🚀"
        className="text-primary-cta montserrat text-6xl"
      /> */}
    </div>
  );
};
